import type { TiendaContenidoDTO } from "./types";

export const INT_VERSION_ESQUEMA_CONTENIDO = 1;

export interface ResultadoNormalizacionContenido {
    contenido: TiendaContenidoDTO;
    bitContenidoMigrado: boolean;
}

export type GeneradorUniIdBloque = () => string;

export const generarUniIdBloque: GeneradorUniIdBloque = () => {
    if (typeof globalThis.crypto?.randomUUID === "function") {
        return globalThis.crypto.randomUUID();
    }
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (vchCaracter) => {
        const intAleatorio = Math.floor(Math.random() * 16);
        const intValor = vchCaracter === "x" ? intAleatorio : (intAleatorio & 0x3) | 0x8;
        return intValor.toString(16);
    });
};

export const esUniIdBloqueValido = (uniIdBloque: string | undefined): boolean =>
    !!uniIdBloque &&
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
        uniIdBloque.trim(),
    );

export const normalizarContenidoTemplate = (
    contenido: TiendaContenidoDTO,
    generarUniId: GeneradorUniIdBloque = generarUniIdBloque,
): ResultadoNormalizacionContenido => {
    let bitContenidoMigrado = contenido.intVersionEsquema !== INT_VERSION_ESQUEMA_CONTENIDO;
    const uniIdsBloque = new Set<string>();

    const bloquesHome = contenido.bloquesHome.map((bloque) => {
        const uniIdBloque = bloque.uniIdBloque?.trim();
        const vchUniIdNormalizado = uniIdBloque?.toLowerCase();
        const bitUniIdUtilizable =
            esUniIdBloqueValido(uniIdBloque) &&
            !!vchUniIdNormalizado &&
            !uniIdsBloque.has(vchUniIdNormalizado);

        if (bitUniIdUtilizable) {
            uniIdsBloque.add(vchUniIdNormalizado);
            return bloque;
        }

        bitContenidoMigrado = true;
        let uniIdGenerado = generarUniId();
        while (
            !esUniIdBloqueValido(uniIdGenerado) ||
            uniIdsBloque.has(uniIdGenerado.toLowerCase())
        ) {
            uniIdGenerado = generarUniId();
        }
        uniIdsBloque.add(uniIdGenerado.toLowerCase());
        return { ...bloque, uniIdBloque: uniIdGenerado };
    });

    if (!bitContenidoMigrado) {
        return { contenido, bitContenidoMigrado: false };
    }

    return {
        contenido: {
            ...contenido,
            intVersionEsquema: INT_VERSION_ESQUEMA_CONTENIDO,
            bloquesHome,
        },
        bitContenidoMigrado: true,
    };
};
